

























import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import AnswerEntry from "@/models/progress/answer-entry";
import GlobalMixin from "@/mixins";

@Component({
    components: {}
})
export default class ProgressAnswer extends GlobalMixin {
    @Prop({
        default: 100
    })
    public maxValue!: number;

    @Prop({
        default: ''
    })
    public unit!: string;

    @Prop()
    public goalDetails: any;

    @Prop({
      default: false
    })
    public debug!: boolean;

    @Prop({
        default: []
    })
    public entries!: AnswerEntry[];

    public selectedFeedbackIndex: any = null;

    @Watch('entries')
    public onEntriesChange(value: string, oldValue: string) {
        this.selectedFeedbackIndex = this.entries.length - 1;
    }

    get websiteId() {
        return this.$store.state.data ? this.$store.state.data.website_id : '';
    }

    get doesNotHaveFeedbackForSelectedIndex() {
      return !this.selectedFeedbackIndex || !this.entries[this.selectedFeedbackIndex] || !this.entries[this.selectedFeedbackIndex].feedback_label
    }

    public selectFeedback(index: number) {
        if (this.entries[index].value_label || true) {
            this.selectedFeedbackIndex = index;
        }
        this.track('Goal Day Toggle', 'Day' + (index + 1), this.goalDetails.goal, this.websiteId)
    }

    private mounted() {
        this.selectedFeedbackIndex = this.entries.length - 1;
        /*
        while ((!this.entries[i].feedback_label) && i > 0) {
            i--;
        }
        if (this.entries[i].feedback && this.entries[i].feedback_label) {
            this.selectedFeedbackIndex = i;
        }
         */
    }

}
